import { styled } from '../jss-style';
import switchStyle from './switch';

const useSwitchStyle = styled(switchStyle, 'switch');
export { switchStyle, useSwitchStyle };
export default useSwitchStyle;
